module.exports = {
        srcSet: __webpack_public_path__ + "static/media/smartphone_play-500.c8e743f8.webp"+" 500w",
        images: [{path: __webpack_public_path__ + "static/media/smartphone_play-500.c8e743f8.webp",width: 500,height: 500}],
        src: __webpack_public_path__ + "static/media/smartphone_play-500.c8e743f8.webp",
        toString: function(){return __webpack_public_path__ + "static/media/smartphone_play-500.c8e743f8.webp"},
        
        width: 500,
        height: 500
      }